import { render } from "./CrawlLeaving.vue?vue&type=template&id=47ba6df0&scoped=true"
import script from "./CrawlLeaving.vue?vue&type=script&lang=js"
export * from "./CrawlLeaving.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-47ba6df0"

export default script